/**
 * STYLING: Plain Tailwind ONLY!
 */

interface TextToolInputProps {
  toolCode: string;
  prompt: string;
  onPromptChange: (val: string) => void;
  systemPrompt: string;
  onSystemPromptChange: (val: string) => void;
  placeholder: string;
  canEditSystem: boolean;
}

export function TextToolInput({
  toolCode,
  prompt,
  onPromptChange,
  systemPrompt,
  onSystemPromptChange,
  placeholder,
  canEditSystem,
}: TextToolInputProps) {
  return (
    <div className="space-y-4">
      {/* System Prompt (collapsible) */}
      <details className="group">
        <summary className="cursor-pointer text-sm font-medium text-neutral-700 dark:text-neutral-300 hover:text-neutral-900 dark:hover:text-neutral-100">
          System Prompt (erweitert)
        </summary>
        <textarea
          value={systemPrompt}
          onChange={(e) => onSystemPromptChange(e.target.value)}
          readOnly={!canEditSystem}
          rows={3}
          className={`mt-2 w-full px-3 py-2 border border-neutral-300 dark:border-neutral-700 rounded-lg font-mono text-sm bg-white dark:bg-neutral-900 text-neutral-900 dark:text-neutral-100 focus:ring-2 focus:ring-primary-500 ${!canEditSystem ? 'opacity-75 cursor-not-allowed' : ''}`}
        />
      </details>

      {/* User Prompt */}
      <div>
        <label className="block text-sm font-medium text-neutral-700 dark:text-neutral-300 mb-2">
          Dein Prompt *
        </label>
        <textarea
          id={`text-tool-prompt-${toolCode}`}
          value={prompt}
          onChange={(e) => onPromptChange(e.target.value)}
          placeholder={placeholder}
          rows={5}
          className="w-full px-3 py-2 border border-neutral-300 dark:border-neutral-700 rounded-lg text-sm bg-white dark:bg-neutral-900 text-neutral-900 dark:text-neutral-100 placeholder:text-neutral-500 focus:ring-2 focus:ring-primary-500"
        />
      </div>
    </div>
  );
}
